import React from "react";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";
import { localBusinessSchema, generateBreadcrumbSchema } from "../utils/schemaMarkup";

const Contact = () => {
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: "Home", url: "https://www.ceekayenterprise.com/" },
    { name: "Contact", url: "https://www.ceekayenterprise.com/contact" },
  ]);

  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [localBusinessSchema, breadcrumbSchema],
  };

  return (
    <div className="page active">
      <SEO
        title="Contact Ceekay Enterprise | Industrial Chemical Supplier | Mumbai, India"
        description="Get in touch with Ceekay Enterprise for industrial chemical inquiries, bulk orders, and technical support. Located in Mumbai, Maharashtra. Call +91-9322629818 or email ceekayent@yahoo.com. Fast response, competitive pricing."
        keywords="contact Ceekay Enterprise, chemical supplier contact Mumbai, industrial chemical inquiry, bulk chemical order, chemical importer contact India"
        canonical="https://www.ceekayenterprise.com/contact"
        schema={combinedSchema}
      />
      <h1 className="page-title">Contact Us</h1>
      <div className="contact-content">
        <ContactForm />

        <div className="contact-info">
          <h3 style={{ marginBottom: "20px" }}>Contact Information</h3>
          <div className="contact-item">
            <div className="contact-icon">📍</div>
            <div>
              <strong>Registered Address:</strong>
              <br />
              215, Reena Complex, Ramdev Pir Rd, opp Neelkanth Corporate Park,
              <br />
              Vidyavihar West, Mumbai, Maharashtra 400086,
              <br />
              Maharashtra, India
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">📞</div>
            <div>
              <strong>Phone:</strong>
              <br />
              WhatsApp : +91-9322629818
              <br />
              Office : +91-9322629818
              <br />
              Office Landline : +91-2235550545
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">📧</div>
            <div>
              <strong>Email:</strong>
              <br />
              ceekayent@yahoo.com
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">🏦</div>
            <div>
              <strong>Banking Partners:</strong>
              <br />
              Union Bank
              <br />
              SVC Co-operative Bank Ltd
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">💳</div>
            <div>
              <strong>Payment Methods:</strong>
              <br />
              Cash, Credit Card, Cheque, DD
              <br />
              Online Transfer, Bank Transfer
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">🚚</div>
            <div>
              <strong>Shipping:</strong>
              <br />
              By Road, By Sea, By Air, By Cargo
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
